"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionFieldOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var journey_services_1 = require("@athena-portal/journey-services");
var InteractionFieldOutputWidget = /** @class */ (function (_super) {
    __extends(InteractionFieldOutputWidget, _super);
    function InteractionFieldOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            lookupValues: []
        };
        return _this;
    }
    InteractionFieldOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        var lookupName = this.getSetting("lookupName", "");
        if (lookupName) {
            this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues
                });
            }, function () {
                console.log("Something went wrong");
            });
        }
    };
    InteractionFieldOutputWidget.prototype.render = function () {
        var interactionFieldValue = this.bindFromField(this.props.question.interactionField);
        if (interactionFieldValue) {
            if (this.getSetting("lookupName", "")) {
                var lookup = this.state.lookupValues.find(function (listItem) { return listItem.id === interactionFieldValue; });
                if (lookup) {
                    interactionFieldValue = lookup.value;
                }
                else {
                    interactionFieldValue = "";
                }
            }
            if (this.getSetting("isDateField", false)) {
                var valueAsMoment = moment(interactionFieldValue, moment.ISO_8601);
                if (valueAsMoment.isValid()) {
                    interactionFieldValue = valueAsMoment.format(this.getSetting("dateFormat", "DD/MM/YYYY"));
                }
                else {
                    interactionFieldValue = "";
                }
            }
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: this.props.question.name, children: this.props.question.label }), (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control", id: this.props.question.name, value: interactionFieldValue, disabled: true })] }));
    };
    InteractionFieldOutputWidget.prototype.bindFromField = function (field) {
        return journey_services_1.ObjectManipulator.fetchFieldValue(field, this.props.interaction);
    };
    InteractionFieldOutputWidget.prototype.getSetting = function (setting, defaultValue) {
        if (!this.props.question.settings || !this.props.question.settings[setting]) {
            return defaultValue;
        }
        return this.props.question.settings[setting];
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], InteractionFieldOutputWidget.prototype, "lookupService", void 0);
    return InteractionFieldOutputWidget;
}(React.Component));
exports.InteractionFieldOutputWidget = InteractionFieldOutputWidget;
//# sourceMappingURL=InteractionFieldOutputWidget.js.map